import React, { useEffect } from 'react';
import configs from '../../../../../../conf';

const config = configs[process.env.APP_CONF];

const TypebotEmbed = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://vormats-code-deployments.s3.amazonaws.com/assistant-chat/dist/web.js';
        script.type = 'module';
        document.body.appendChild(script);

        script.onload = () => {
            if (window.Typebot) {
                window.Typebot.initStandard({
                    typebot: config.typebotId,
                    apiHost: config.typebotHostUrl
                });
            }
        };

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return <typebot-standard style={{ width: '100%', height: '600px' }}></typebot-standard>;
};

export default TypebotEmbed;
